<template>
  <MBaseDialog :isVisible="isVisible">
    <template #content>
      <!--      <div class="confirm-title" v-html="title"></div>-->
      <div class="confirm-information">
        <ul class="reser-confirm-box">
          <li class="confirm-content" v-html="message"></li>
          <!--          <li><span>예약일자</span>2024-11-06(수)</li>-->
          <!--          <li><span>예약시간</span>07:22</li>-->
          <!--          <li><span>예약코스</span>동코스(E)</li>-->
        </ul>
      </div>
    </template>
    <template #actions>
      <div class="button-wrapper">
        <AButton @click="handleCancel">취소</AButton>
        <AButton @click="handleConfirm" class="on">확인</AButton>
        <!--<AButton @click="handleConfirm" class="pink">확인</AButton>-->
      </div>
    </template>
  </MBaseDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { AButton } from '@atoms';
import { MBaseDialog } from '@molecules';
import { useAlertStore } from '@stores';

const alertStore = useAlertStore();

const isVisible = computed(() => alertStore.isConfirmVisible);
//const information = computed(() => alertStore.information);
const message = computed(() => alertStore.message);

const handleConfirm = () => {
  alertStore.confirm(true);
};

const handleCancel = () => {
  alertStore.cancel();
};
</script>

<style scoped lang="scss">
.confirm-content {
  @apply text-center;
}

.button-wrapper {
  @apply flex justify-center gap-20 items-center mt-10;
  button {
    &:first-child {
      color: #ccc;
    }

    &:last-child {
      background: #eb7617;
      color: #fff;
      padding: 10px 20px;
    }
  }
}

.confirm-title {
  text-align: center;
  font-size: 20px;
  color: #222;
  font-weight: bold;
  padding: 10px 0 22px;
}

.reser-confirm-box {
  max-width: 280px;
  margin: 0 auto 24px;
  padding: 16px 38px 15px;
  border-radius: 16px;
  background-color: #f8f9fc;
  color: #222;
}

.reser-confirm-box span {
  font-weight: bold;
  width: 58px;
  padding-right: 14px;
}

.button-wrapper {
  display: flex;
  gap: 0 7px;
  margin-top: 24px;
}

.button-wrapper button {
  flex-basis: 154px;
  border-radius: 60px;
  background-color: #eee;
  height: 48px;
  color: #222;
}

.button-wrapper button.on {
  background-color: var(--color-main);
  color: #fff;
}

.button-wrapper button.pink {
  background-color: #eb79ae;
  color: #fff;
}

@media (max-width: 884px) {
  .reser-confirm-box {
    width: 100%;
  }
  .confirm-title {
    font-size: var(--f20);
  }
}
</style>
